import { EvaluationContract } from './evaluation.contract';
import { MultireportCategoryResultContract } from './multireport-category-result.contract';

export interface MultireportChildResultContract {
  child_uuid: string;
  evaluations: EvaluationContract[];
  tests: string[];
  category_results: MultireportCategoryResultContract[];
}
